import { Component, OnInit, EventEmitter, ChangeDetectorRef, } from '@angular/core';
import { ConnectedUserComponent } from '../../shared/connectedUserComponent';
import { EbUser } from "../../classes/user";
import { UserService } from "../../services/user.service";
import { Router } from '@angular/router';
import { Statique } from '../../utils/statique';
import { AuthenticationService } from '../../services/authentication.service';
import { Modules, UserRole } from '../../utils/enumeration';
import { SearchCriteria } from '../../utils/searchCriteria';
import { EbEtablissement } from '../../classes/etablissement';
import { EbCompagnie } from '../../classes/compagnie';
import { EtablissementService } from '../../services/etablissement.service';
import { EbLien } from "../../classes/lien";
import { CompagnieService } from '../../services/compagnie.service';
import { Title } from '@angular/platform-browser';


@Component({
	selector: 'app-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.css']
})

export class HeaderComponent extends ConnectedUserComponent implements OnInit {
	public _newUser: EbUser = null;
	ebEtablissement: EbEtablissement = new EbEtablissement();
	ebCompagny: EbCompagnie = new EbCompagnie();

	Modules = Modules;
	Statique = Statique;
	UserRole = UserRole;
	//isLoggedIn: Subject;
	isLoggedInScalar: boolean = false;
	listLiens: Array<EbLien>;

	typeaheadUserSelectEvent: EventEmitter<string> = new EventEmitter<string>();
	listUser: Array<EbUser> = new Array<EbUser>();
	userSelectCt: EbUser;

	constructor(
		protected authenticationService: AuthenticationService,
		private router: Router,
		private userService: UserService,
		private compagnieService: CompagnieService,
		private titleService: Title,
		protected etablissementService?: EtablissementService,
		protected cd?: ChangeDetectorRef,

	) {
		super(authenticationService);
	}

	ngOnInit() {
		//this.isLoggedIn = this.authenticationService.itemValue;
		let self = this;
		self.isLoggedInScalar = AuthenticationService.isAuthenticated();

		self.authenticationService.connectedUser.subscribe(tocken => {
			self.isLoggedInScalar = tocken != null;
			self.userConnected = AuthenticationService.decodeTocken(tocken);
		});

		if (self.userConnected && !self.userConnected.listAccessRights) {
			let criteria: SearchCriteria = new SearchCriteria();
			criteria.withAccessRights = true;
			criteria.ebUserNum = self.userConnected.ebUserNum;
			self.userService.getUserInfo(criteria).subscribe(res => {
				self.userConnected.listAccessRights = res.listAccessRights;
			});
		}

		this.initAutocomplete();

		//get user compagny's link. if its not empty, the dashboard icon will be displayed
		if (AuthenticationService.getConnectedUser().ebCompagnie != null) {
			this.compagnieService.getListLienCompagnie(AuthenticationService.getConnectedUser().ebCompagnie.ebCompagnieNum).subscribe(data => {
				if (data != null && data.length != 0)
					this.listLiens = data;
				else
					this.listLiens == null;
			})
		}
	}

	navigateAndChangeTitle() {
		this.titleService.setTitle('SetCargo');
	  }

	initAutocomplete() {
		this.typeaheadUserSelectEvent
			// .distinctUntilChanged()
			// .debounceTime(200)
			.switchMap(term => {
				let criteria = new SearchCriteria();
				criteria.searchterm = term;
				criteria.size = null;
				criteria.withPassword = true;
				criteria.superAdmin = null;
				criteria.admin = null;
				return this.userService.getListUser(criteria);
			})
			.subscribe(data => {
				this.cd.markForCheck();
				this.listUser = data;
			}, (err) => {
				this.listUser = [];
			});
	}

	logout() {
		this.authenticationService.logout();
		//this.authenticationService.isLoggedInObservable.n
		this.checkChange();

		let appCorp = document.getElementById("corp");
		if (appCorp.classList.contains("opened")) {
			appCorp.classList.remove("opened");
		}

		// this.router.navigate(['/login']);
		window.location.href = window.location.origin + "/login";
	}

	loginAsUser() {
		if (!this.userSelectCt)
			return;

		this.authenticationService.login(this.userSelectCt.email, this.userSelectCt.password, this.userConnected.email, this.userConnected.password, true).subscribe(result => {
			if (result) {
				// redirect to home page
				this.authenticationService.notifySideBarInitUser();
				// this.router.navigate(['home']);
				window.location.href = window.location.origin + "/accueil";

			} else {
				console.log('Email ou mot de passe incorrect');
			}
		},
			error => {
				console.log('Email ou mot de passe incorrect');
			}
		);
	}

	loginBackAsCt() {
		if (!this.userConnected.realUserNum)
			return;

		this.authenticationService.login(this.userConnected.realUserEmail, this.userConnected.realUserPassword, this.userConnected.email!=null ? this.userConnected.email : "email", this.userConnected.password!=null? this.userConnected.password: "password").subscribe(result => {
			if (result) {
				// redirect to home page
				this.authenticationService.notifySideBarInitUser();
				// this.router.navigate(['home']);
				window.location.href = window.location.origin + "/accueil";

			} else {
				//Email ou mot de passe incorrect
			}
		},
			error => {
				//Email ou mot de passe incorrect
			}
		);
	}

	makeActive(path) {
		return this.router.url.indexOf(path) >= 0 ? "-active" : "";
	}

}



// WEBPACK FOOTER //
// ./src/app/shared/header/header.component.ts